export default __webpack_public_path__ + "static/media/logo-1x.787da8f8.png";